<div class="card-grid-skeleton">
  <div *ngIf="showHeadingSkeleton" class="card-grid-skeleton__heading">
    <app-skeleton className="h-24 w-24 r-4 c-post"></app-skeleton>
    <div class="card-grid-skeleton__heading-text">
      <app-skeleton className="h-28 w-55% r-4 c-post"></app-skeleton>
      <app-skeleton className="h-16 w-42% r-4 c-post"></app-skeleton>
    </div>
  </div>

  <div
    *ngFor="let row of resolvedRows"
    class="card-grid-skeleton__row"
  >
    <div
      *ngFor="let i of row.cardIndices"
      class="card-grid-skeleton__card"
      [ngClass]="'card-grid-skeleton__card--' + row.variant"
    >
      <ng-container *ngIf="row.variant === 'stat'">
        <app-skeleton className="h-14 w-160 r-4 c-post"></app-skeleton>
        <div class="card-grid-skeleton__stat-value-row">
          <app-skeleton className="h-28 w-56 r-4 c-post"></app-skeleton>
          <app-skeleton className="h-16 w-88 r-4 c-post"></app-skeleton>
        </div>
      </ng-container>

      <ng-container *ngIf="row.variant === 'detail'">
        <div class="card-grid-skeleton__detail-image">
          <app-skeleton className="h-100% w-100% r-16 c-post"></app-skeleton>
        </div>
        <div class="card-grid-skeleton__detail-content">
          <div class="card-grid-skeleton__detail-header">
            <app-skeleton className="h-28 w-40% r-4 c-post"></app-skeleton>
            <app-skeleton className="h-32 w-72 r-16 c-post"></app-skeleton>
          </div>
          <div class="card-grid-skeleton__detail-meta">
            <app-skeleton className="h-16 w-200 r-4 c-post"></app-skeleton>
            <app-skeleton className="h-16 w-100 r-4 c-post"></app-skeleton>
          </div>
          <app-skeleton className="h-14 w-70% r-4 c-post"></app-skeleton>
          <div class="card-grid-skeleton__detail-tiers">
            <div
              *ngFor="let _ of row.tierIndices"
              class="card-grid-skeleton__detail-tier"
            >
              <app-skeleton className="h-14 w-60% r-4 c-post"></app-skeleton>
              <app-skeleton className="h-20 w-80% r-4 c-post"></app-skeleton>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="row.variant === 'ticket-purchased'">
        <div class="card-grid-skeleton__detail-image">
          <app-skeleton className="h-100% w-100% r-16 c-post"></app-skeleton>
        </div>
        <div class="card-grid-skeleton__tp-content">
          <app-skeleton className="h-28 w-55% r-4 c-post"></app-skeleton>
          <div class="card-grid-skeleton__detail-meta">
            <app-skeleton className="h-16 w-200 r-4 c-post"></app-skeleton>
            <app-skeleton className="h-16 w-100 r-4 c-post"></app-skeleton>
          </div>
          <div class="card-grid-skeleton__tp-metrics">
            <div class="card-grid-skeleton__tp-metric">
              <app-skeleton className="h-14 w-120 r-4 c-post"></app-skeleton>
              <app-skeleton className="h-22 w-40 r-4 c-post"></app-skeleton>
            </div>
            <div class="card-grid-skeleton__tp-metric">
              <app-skeleton className="h-14 w-130 r-4 c-post"></app-skeleton>
              <app-skeleton className="h-22 w-100 r-4 c-post"></app-skeleton>
            </div>
          </div>
          <div class="card-grid-skeleton__tp-cta">
            <app-skeleton className="h-44 w-160 r-22 c-post"></app-skeleton>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="row.variant === 'cta'">
        <app-skeleton className="h-44 w-180 r-22 c-post"></app-skeleton>
      </ng-container>

      <ng-container *ngIf="row.variant === 'feature'">
        <ng-container *ngIf="featureLayout(row, i) === 'media'">
          <app-skeleton className="h-80 w-80 r-50% c-post"></app-skeleton>
          <div
            class="card-grid-skeleton__feature-text card-grid-skeleton__feature-text--scanner"
          >
            <app-skeleton className="h-28 w-96% r-4 c-post"></app-skeleton>
            <app-skeleton className="h-14 w-62% r-4 c-post"></app-skeleton>
          </div>
          <div class="card-grid-skeleton__feature-body">
            <app-skeleton className="h-240 w-full r-4 c-bgt"></app-skeleton>
          </div>
          <app-skeleton className="h-44 w-200 r-22 c-post"></app-skeleton>
        </ng-container>

        <ng-container *ngIf="featureLayout(row, i) === 'text'">
          <app-skeleton className="h-80 w-80 r-50% c-post"></app-skeleton>
          <div
            class="card-grid-skeleton__feature-text card-grid-skeleton__feature-text--manual"
          >
            <app-skeleton className="h-28 w-82% r-4 c-post"></app-skeleton>
            <div class="card-grid-skeleton__feature-desc-bars">
              <app-skeleton className="h-14 w-full r-4 c-post"></app-skeleton>
              <app-skeleton className="h-14 w-92% r-4 c-post"></app-skeleton>
              <app-skeleton className="h-14 w-68% r-4 c-post"></app-skeleton>
            </div>
          </div>
          <app-skeleton className="h-44 w-220 r-22 c-post"></app-skeleton>
        </ng-container>
      </ng-container>
    </div>
  </div>
</div>
